// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import wx from 'jweixin-module'
import * as echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'
//import Vconsole from 'vconsole'
import { getBrowserType } from './util/common'

Vue.prototype.$wx = wx;

Vue.prototype.$echarts = echarts;

Vue.prototype.$browserType = getBrowserType();

//let vConsole = new Vconsole();

//Vue.use(vConsole);

Vue.use(VueClipboard);

Vue.use(ElementUI);

Vue.config.productionTip = false;

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

export default app




// WEBPACK FOOTER //
// ./src/main.js